// One-time, dismissible install nudge for engaged mobile-browser visitors
// (M3 Phase 3). Sits below the alert layers; tap opens the install modal,
// dismiss persists so it never returns. Eligibility lives in
// install-hint-eligibility.ts; this is only the view.
type Tr = (k: string, p?: Record<string, string | number>) => string;

export interface InstallHintOpts {
  t: Tr;
  onOpen: () => void;
  onDismiss: () => void;
}

export function installHint(o: InstallHintOpts): HTMLElement {
  const root = document.createElement("div");
  root.className = "install-hint";
  root.setAttribute("role", "complementary");
  root.setAttribute("aria-label", o.t("install.hint.title"));
  root.setAttribute("data-install-hint", "");

  const open = document.createElement("button");
  open.type = "button";
  open.className = "install-hint__cta";
  open.setAttribute("data-action", "open-install");
  open.append(
    Object.assign(document.createElement("span"), { className: "bx-body", textContent: o.t("install.hint.body") }),
    Object.assign(document.createElement("span"), { className: "bx-microlabel install-hint__more", textContent: o.t("install.hint.cta") }),
  );
  open.addEventListener("click", o.onOpen);

  const dismiss = document.createElement("button");
  dismiss.type = "button";
  dismiss.className = "install-hint__dismiss";
  dismiss.textContent = "✕";
  dismiss.setAttribute("aria-label", o.t("install.hint.dismiss"));
  dismiss.setAttribute("data-action", "dismiss-install");
  dismiss.addEventListener("click", o.onDismiss);

  root.append(open, dismiss);
  return root;
}
